export const RESERVATION = '/reservation/' as const
export const RESERVATION_ROOM = `${RESERVATION}room` as const
export const RESERVATION_LIST = `${RESERVATION}list` as const
